import { render, staticRenderFns } from "./CheckboxSwitch.vue?vue&type=template&id=b589009c"
import script from "./CheckboxSwitch.vue?vue&type=script&lang=js"
export * from "./CheckboxSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports